import { render, staticRenderFns } from "./FloatingDock.vue?vue&type=template&id=a32345c4&scoped=true"
import script from "./FloatingDock.vue?vue&type=script&lang=js"
export * from "./FloatingDock.vue?vue&type=script&lang=js"
import style0 from "./FloatingDock.vue?vue&type=style&index=0&id=a32345c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32345c4",
  null
  
)

export default component.exports